/**
 * 导出Excel工具函数
 */

/**
 * 将数据导出为Excel文件
 * @param {Array} data - 要导出的数据数组
 * @param {Array} headers - 表头配置 [{title: '列名', key: '字段名'}]
 * @param {String} filename - 导出文件名
 */
export function exportToExcel(data, headers, filename = 'export.xlsx') {
  try {
    // 创建工作表数据
    const worksheetData = [];
    
    // 添加表头
    const headerRow = {};
    headers.forEach((header, index) => {
      headerRow[header.key] = header.title;
    });
    worksheetData.push(headerRow);
    
    // 添加数据行
    data.forEach(row => {
      const dataRow = {};
      headers.forEach(header => {
        dataRow[header.key] = row[header.key] !== undefined && row[header.key] !== null ? row[header.key] : '';
      });
      worksheetData.push(dataRow);
    });
    
    // 创建CSV内容
    const csvContent = convertToCSV(worksheetData);
    
    // 创建下载链接
    const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    return true;
  } catch (error) {
    console.error('导出Excel失败:', error);
    return false;
  }
}

/**
 * 将对象数组转换为CSV格式
 * @param {Array} data - 对象数组
 * @returns {String} CSV格式字符串
 */
function convertToCSV(data) {
  if (!data || data.length === 0) return '';
  
  // 获取所有列名
  const columns = Object.keys(data[0]);
  
  // 创建CSV内容
  let csv = '';
  
  // 添加表头
  csv += columns.map(col => `"${col}"`).join(',') + '\n';
  
  // 添加数据行
  data.forEach(row => {
    const values = columns.map(col => {
      const value = row[col];
      // 处理包含逗号或引号的值
      if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
        return `"${value.replace(/"/g, '""')}"`;
      }
      return `"${value}"`;
    });
    csv += values.join(',') + '\n';
  });
  
  return csv;
}

/**
 * 将JSON数据转换为Excel并下载
 * @param {Array} jsonData - JSON数据
 * @param {Array} headers - 表头配置
 * @param {String} fileName - 文件名
 */
export function jsonToExcel(jsonData, headers, fileName) {
  // 调用导出函数
  try {
    const success = exportToExcel(jsonData, headers, fileName);
    return success;
  } catch (error) {
    console.error('导出失败:', error);
    return false;
  }
}

export default {
  exportToExcel,
  jsonToExcel
};